module.exports = __webpack_public_path__ + "img/or_yes.91997003.png";